Librarian.Modules.Processed = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-processed-",
        count: 10
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || !Librarian.specialCategories || (typeof Librarian.specialCategories.UserApproved != "number"))
            return;

        this.parent();


        // Save this so it can be cancelled later if needed
        Librarian.myProcView = new Librarian.MyProcessedView({
            container: this.containerEl,
            addSpacer: false,
            sendEnabled: Librarian.event.canShare,
            externalCrmEnabled: Librarian.externalCrm.attachCreated,
            deleteEnabled: Librarian.create.allowCreateDelete,
            addTitle: Librarian.create.showTitle
        });
        Librarian.myProcView.load(this.options.count);
    }
});